import Vuex from 'vuex';
// state
const state = {
    nowThemeInfo: 'theme', //当前主题
    themes: ['theme1', 'theme2'] ,//所有主题
    ishome: true,//判断是否是主页,防止其他页面触发监听浏览器分辨率变化
    listPagePars: new Map(), //查询页的查询条件
};

// 同步操作
const mutations = {
    SET_THEMEINFO(state, theme){
	    state.nowThemeInfo = theme;
    },
    SET_ISHOME(state, is){
        state.ishome = is
    },
    SAVE_LIST_PAGE_PARS: (state, { path, pars }) => {
      state.listPagePars.set(path, pars);
    },
    RESET_LIST_PAGE_PERS: (state) => {
      state.listPagePars = new Map();
    }
};
const actions = {
  saveListPagePars: ({ commit }, { path, pars }) => {
    commit('SAVE_LIST_PAGE_PARS', { path, pars });
  }
}
const getters = {
    ishome :(state) => state.ishome,
}
const Store = () => {
    return new Vuex.Store({
        state,
        mutations,
        actions,
        getters
    });
};

export default Store;



// WEBPACK FOOTER //
// ./src/store/store.js